import { observer } from "mobx-react-lite";

import { usePlaygroundDialogStore } from "../playground-dialog-store";
import { PlaygroundDialogType } from "../constants";

import { TutorialVideoDialog } from "@/components/TutorialVideoDialog";

export const NoInputVariables = observer(() => {
  const store = usePlaygroundDialogStore();

  return (
    <TutorialVideoDialog
      tutorialLink="https://www.loom.com/embed/2892a91ae46e4344ba8ac1cdb1b12e53?sid=b84a725a-5908-4250-aaa4-f0ecb1d94dcd"
      tutorialTitle="Creating your first prompt"
      title="Have you tried using input variables? 🤔"
      description={
        <div className="flex flex-col gap-2">
          <span>
            The best way to write powerful prompts in PromptLayer is with dynamic input variables.
            These placeholders are fill-in-the-blanks that make your prompt template re-usable.
          </span>
          <span>Watch the short video below to see how easy it is to use them.</span>
        </div>
      }
      confirmButtonText="Got it!"
      onConfirm={() => {
        localStorage.setItem("showInputVariablesTutorial", "false");
        store.onClose?.();
        store.setIsDialogOpen({
          isOpen: false,
          dialogType: PlaygroundDialogType.NoInputVariables,
        });
      }}
      onCancel={() => {
        localStorage.setItem("showInputVariablesTutorial", "false");
        store.onClose?.();
        store.setIsDialogOpen({
          isOpen: false,
          dialogType: PlaygroundDialogType.NoInputVariables,
        });
      }}
      isOpen={store.isDialogOpen}
    />
  );
});
